import { CompanyActivity } from '../components';
import { useCompanyActivity } from '../hooks';
import { PageComponentProps } from '../types';

export const CompanyActivityStep = ({ canGoBack }: PageComponentProps) => {
  const { submitLoading, initialValues, onSubmit, goToBack } =
    useCompanyActivity();

  return (
    <CompanyActivity
      canGoBack={canGoBack}
      initialValues={initialValues}
      submitLoading={submitLoading}
      onGoBack={goToBack}
      onSubmit={onSubmit}
    />
  );
};
